import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface ChevronImageProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    $isFilterOpen: boolean
    src: string
    alt: string
    dataTestId: string
}

const ChevronImage = memo(({templating, $isFilterOpen, src, alt, dataTestId}: ChevronImageProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <ComponentName $isFilterOpen={$isFilterOpen} src={src} alt={alt} data-testid={dataTestId} />
        </Suspense>
    )
})

ChevronImage.displayName = "ChevronImage"

export default connect(ChevronImage)
